.uploadFiles {
  position: relative;
  display: inline-flex;

  button {
    display: inline-flex;
    align-items: center;
    padding: 13px 12px;
    border-radius: 12px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    border: 0;
    
    svg {
      margin-right: 5px;
    }
  }
  input {
    display: none;
  }
}

.clearAndText {
  display: flex;
  align-items: center;
  margin-top: 12px;
  text-transform: capitalize;
  height: 40px;
  padding: 10.5px 12px;
  border-radius: 12px;
  box-sizing: border-box;
  justify-content: space-between;

  .textContainer {
    display: flex;
    width: calc(100% - 30px);
    align-items: center;

    .fileNameText {
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding-right: 6px;
      font-size: 16px;
      font-weight: 500;
    }

    .sizeText {
      font-size: 16px;
      font-weight: 500;
      margin: 0;
    }
  }

  .clearIconContainer {
    display: flex;
    height: 24px;
    width: 24px;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    &::before {
      position: absolute;
      content: "";
      height: 0;
      width: 0;
      background-color: #d8dde3;
      transition: height 0.25s, width 0.25s;
      left: 50%;
      top: 50%;
      border-radius: 100%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      &::before {
        height: 24px;
        width: 24px;
      }
    }
    .clearIcon {
      font-size: 16px;
      z-index: 1;
    }
  }
  &::before {
    @include themify($themes) {
      color: themed("btn-secondary");
    }
  }


  svg {
    cursor: pointer;
    opacity: 0.9;
  }
}

.icon {
  pointer-events: auto;
}
